<template >
  <sc-panel-navigator
      ref="sidePanel"
      :drawer-width="drawerWidth"
      :content-drawable="true"
      :enable="isMobileDevice()"
      :backdrop="false"
      :z-index="0"
      @slide-end="handleContentFrame"
      @slide-move="handleContentFrame"
  >
    <div

        class="drawer-content"
        style="border: 1px solid white" >
      <!-- <p>{{ userProfile.invoiceGroups }}!!!</p> -->
      <el-row
          :gutter="20"
          style="padding: 20px" >
        <el-col :span="24" >
          <el-col :md="userProfile.invoiceGroups ? 20 : 24" >
            <el-radio-group
                v-model="selectedSira"
                fill="green"
                class="invoice-options"
                @change="$router.replace({ query: { kind: selectedSira } })"
            >
              <el-radio-button label="invoice" >Τιμολογια</el-radio-button >
              <el-radio-button label="receipt" >ΑΠΥ</el-radio-button >
              <el-radio-button label="pistotiko" >Πιστωτικα</el-radio-button >
            </el-radio-group >
            <!-- <el-button
              style=" margin-top: -6px;float:right"
              circle
              type="success"
              @click="displaySums()"
            >
              <i class="material-icons">functions</i>
            </el-button>-->
          </el-col >
          <el-col
              v-if="userProfile.invoiceGroups"
              :md="4"
              style="margin-bottom: 15px"
          >
            <el-select
                v-model="selectedTimoGroup"
                placeholder="Select"
                style="width: 100%"
            >
              <el-option
                  v-for="(groupLabel, groupId) in userProfile.invoiceGroups"
                  :key="groupId"
                  :label="groupId"
                  :value="groupId"
              ></el-option >
            </el-select >
          </el-col >
          <el-col
              :md="24"
              style="margin-bottom: 15px" >
            <el-input
                v-model="searchBusiness"
                placeholder="Όνομα, ΑΦΜ, Περιγραφή..."
                clearable
            ></el-input >
          </el-col >
          <el-col :md="24" >
            <!-- =={{dateRange}}== -->
            <ctk-dater
                v-model="dateRange"
                range-by-seprator="-"
                range
                export-format="dd/mm/yy"
                :customise-shortcuts="dtshorts"
            ></ctk-dater >
            <!-- <r-dater v-model="dateRange"></r-dater> -->
          </el-col >
        </el-col >
      </el-row >
      <el-menu
          default-active="all"
          mode="horizontal"
          background-color="#009688"
          text-color="#fff"
          active-text-color="#ffd04b"
          @select="selectInvoiceState"
      >
        <el-menu-item index="all" >
          <i class="far fa-file-alt" ></i >
          <span v-if="!isMobileDevice" >Ολα</span >
        </el-menu-item >

        <el-menu-item index="issed" >
          <i class="fas fa-file-invoice" ></i >
          <span v-if="!isMobileDevice" >Εκδομενα</span >
        </el-menu-item >
        <el-menu-item index="notIssued" >
          <i class="fas fa-pencil-ruler" ></i >
          <span v-if="!isMobileDevice" >Πρόχειρα</span >
        </el-menu-item >
        <el-menu-item index="gadgets" >
          <i
              class="material-icons"
              style="color: #fff" >functions</i > <i
            class="material-icons"
            style="color: #fff" >share</i >
        </el-menu-item >
      </el-menu >
      <s-table
          v-if="loaded"
          :key="clock"
          v-model="listedInvoices"
          default-sort="aa"
          :top-offset="140"
          row-key-field="timologioId"
          height-wish="90%"
          :selection-id="selectedInvoice ? selectedInvoice.timologioId : null"
          ref="listedInvoices"
          :col-definitions="colDefinitions"
          modx-processor="timologio/getlist"
          :r-query="qInvoices"
          :row-class-factory="invoiceListClass"
          xwake-up-path="timologiera"
          simple-lazy-loader
          :mobileMode="isMobileDevice()"
          @cell-clicked="loadInvoice"
      ></s-table >
    </div >
    <div slot="body" >
      <div
          :style="contentFrame + ';height:100vh;overflow:auto;'"
          v-loading="processing" >
<!--        <r-menu :logo="userProfile.logo" >-->
<!--          <el-button-->
<!--              class="simple_button"-->
<!--              type="text"-->
<!--              @click="toggleDrawer()" >-->
<!--            <i-->
<!--                v-if="!drawerIsOpen"-->
<!--                class="material-icons"-->
<!--            >chrome_reader_mode</i-->
<!--            > <i-->
<!--              v-else-->
<!--              class="material-icons" >close</i >-->
<!--          </el-button >-->
<!--        </r-menu >-->

        <el-row
            class="actions_btns"
            type="flex"
            xjustify="center" >
          <el-button
              size="small"
              type="success"
              @click="
                $router.push({
                  name: 'timologio',
                  params: { id: 'new' },
                  query: $route.query
                });
                $refs['businessDetails'].focus();
              "
          >
            <i class="fas fa-plus-square" ></i >++
          </el-button >
          <s-responsive-panel
              :go-responsive="1320"
              toast-icon="fas fa-cog" >
            <el-button
                size="small"
                type="success"
                @click="
                $router.push({
                  name: 'timologio',
                  params: { id: 'new' },
                  query: $route.query
                });
                $refs['businessDetails'].focus();
              "
            >
              <i class="fas fa-plus-square" ></i >++
            </el-button >

            <el-button
                size="small"
                v-if="selectedInvoice.timologioId"
                type="warning"
                @click="canEdit = !canEdit"
            >
              <i class="fas fa-pencil-alt" ></i >
            </el-button >

            <div
                v-if="selectedInvoice.aa && selectedInvoice.aa > 0"
                class="text-center round_btn_left"
                style="width: 120px"
            >
              <el-button
                  type="success"
                  size="small"
                  plain
                  @click="handlePayment()" >
                <i
                    v-if="selectedInvoice.payed == 1"
                    class="far fa-thumbs-up"
                ></i > <i class="fas fa-euro-sign" ></i >
              </el-button >
              <el-button
                  type="danger"
                  size="small"
                  plain
                  @click="cancelInvoice()" >
                <i
                    v-if="selectedInvoice.canceled != 1"
                    class="fas fa-ban" ></i > <i
                  v-else
                  class="fas fa-redo-alt" ></i >
              </el-button >
              <div v-if="isWindowSize('sm')" >
                <el-button


                    class="print_btn"
                    @click="printerLang = printerLang == 'gr' ? 'en' : 'gr'"
                >{{ printerLang == "gr" ? "Ελ" : "En" }}
                </el-button
                >
                <el-button

                    type="success" >
                  <a
                      target="_blank"
                      class="print_btn"
                      title="εκτυπωση"
                      :href="printLink"
                  >
                    <i class="fas fa-print" ></i >
                  </a >
                </el-button >
              </div >
            </div >
            <el-button
                v-if="selectedInvoice.timologioId"
                type="warning"
                plain
                title="Αντιγραψε αυτο το παραστατικο"
                @click="copyInvoice()"
            >
              <i class="fas fa-copy" ></i >
            </el-button >

            <el-button
                v-if="selectedInvoice.timologioId"
                type="danger"
                plain
                :disabled="!canEdit"
                title="Μεταφορά των εγγραφών αυτού του παραστατικού σε άλλο"
                @click="moveTransactions()"
            >
              <i class="fas fa-arrows-alt" ></i >
            </el-button >
            <el-button
                v-if="selectedInvoice.timologioId"
                type="danger"
                plain
                @click="deleteInvoice()"
            >
              <i class="fas fa-trash" ></i >
            </el-button >
          </s-responsive-panel >

          <el-col
              v-if="selectedInvoice.timologioId"
              :sm="24"
              :xs="8"
              class="text-right"
          >
            <el-button
                v-if="!isWindowSize('sm')"
                type="info"
                round
                class="print_lang"
                @click="printerLang = printerLang == 'gr' ? 'en' : 'gr'"
            >{{ printerLang == "gr" ? "Ελ" : "En" }}
            </el-button
            >
            <el-button
                v-if="!isWindowSize('sm')"
                type="success" >
              <a
                  target="_blank"
                  class="print_btn"
                  title="εκτυπωση"
                  :href="printLink"
              >
                <i class="fas fa-print" ></i >
              </a >
            </el-button >
            <!--             <p>{{selectedInvoice}}</p>-->
            <div class="stamp" >
              <!-- <div v-if="isWindowSize('md')" class="outline-text boxed pl">
                <span v-if="selectedInvoice.aa && selectedInvoice.aa > 0">
                  <i class="fas fa-clipboard-check"></i>
                  <strong class="outline-text">{{ selectedInvoice.aa }}</strong>
                </span>

                <el-button v-else type="primary" @click="issueInvoice()">
                  <i class="fas fa-clipboard-check"></i>
                </el-button>
              </div> -->
              <div class="outline-text boxed pl" >
                <el-button
                    :title="selectedInvoice.aade_uid?'Εχει αποστασλεί στην ΑΑΔΕ':'Αποστολή στην ΑΑΔΕ τώρα'"
                    :plain="selectedInvoice.aade_uid?false:true"
                    :type="selectedInvoice.aade_uid?'success':'warning'"
                    v-if="selectedInvoice.aa"
                    @click="exportAADE(true)" ><i class="fa-2x fa-lg fab fa-expeditedssl" ></i >
                </el-button >
                <span v-if="selectedInvoice.kind == 'receipt'" >ΑΠΥ</span >
                <span
                    v-else-if="selectedInvoice.kind == 'pistotiko'"
                >Πστ.</span
                >

                <span class="outline-text" >{{ selectedInvoice.timo_group }}</span >
                <span v-if="selectedInvoice.aa && selectedInvoice.aa > 0" >
<!--                  <i class="fas fa-clipboard-check" ></i >-->
                  <strong class="outline-text" >{{ selectedInvoice.aa }}</strong >
                </span >

                <el-button
                    v-else
                    type="primary"
                    plain
                    @click="issueInvoice()" >
                  <i class="fas fa-clipboard-check" ></i >
                </el-button >
              </div >
            </div >
          </el-col >
        </el-row >
        <!-- <p>{{$route.params}}</p> -->
        <el-row >
          <business-panel
              v-show="$route.params.id == 'new' || selectedInvoice.timologioId"
              ref="businessDetails"
              xkey="clock"
              :disabled="!canEdit"
              :search-string="selectedInvoice.business_name"
              :confirm-update="
              selectedInvoice.aa != null && selectedInvoice.aa != ''
            "
              :business-id="selectedInvoice.businessId"
              embed-mode
              @businessChange="changeBusiness"
          ></business-panel >
        </el-row >
        <!-- <div v-if="$route.params.id!='new'&&!selectedInvoice.timologioId">
          <h2 class="text-center">Σύνολα κινήσεων</h2>

          <h3 class="text-center">
            <i class="material-icons">functions</i>
            {{Sums.total}}
          </h3>
          <h3 class="text-center">
            <small>+ΦΠΑ:</small>
            {{Sums.totalvat}}
          </h3>
          <h3 class="text-center">={{Sums.totalall}}</h3>
        </div>-->
        <!-- <p>{{selectedInvoice}}</p> -->
        <el-card
            v-if="selectedInvoice.timologioId"
            shadow="always"
            style="overflow: visible"
        >
          <el-row
              slot="header"
              class="clearfix"
              :gutter="5" >
            <el-col :sm="9" >
              <el-date-picker
                  v-model="selectedInvoice.date"
                  :disabled="!canEdit"
                  type="date"
                  style="width: 100%"
                  placeholder="Pick a day"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  @change="updateInvoice()"
              >
                <template
                    slot="prepend"
                >Ημ/νια
                </template
                >
              </el-date-picker >
            </el-col >
            <el-col
                :sm="6"
                :xs="9" >
              <el-input
                  v-model="selectedInvoice.vat"
                  :disabled="!canEdit"
                  @input="updateInvoice(null, true)"
              >
                <template
                    slot="prepend"
                >%
                </template
                >
              </el-input >
            </el-col >
            <!-- <el-row :sm="4">
            <el-input v-model="selectedInvoice.vat">
              <template slot="prepend">ΦΠΑ</template>
            </el-input>
            </el-row>-->
            <el-col
                :sm="9"
                :xs="15" >
              <el-input
                  v-model="selectedInvoice.place"
                  :disabled="!canEdit" >
                <template slot="prepend" >
                  <i class="material-icons" >room</i >
                </template >
              </el-input >
            </el-col >
          </el-row >
          <!-- <el-row v-if="isWindowSize('md')">
            <el-col style="padding: 15px 0px 15px 0px">
              <el-button
                type="primary"
                style="width: 100%"
                @click="showDetails = !showDetails"
              >
                <small>αξια</small>
                {{ $theMoney(aggregators.costincl) }}&euro;
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-row
                v-show="(showDetails = showDetails)"
                style="
                  background: #ffffff;
                  position: absolute;
                  z-index: 3;
                  border-radius: 5px;
                  padding: 10px;
                "
              >
                <el-col>
                  <small>καθ.αξια</small>
                  {{ $theMoney(aggregators.cost) }}&euro;
                </el-col>
                <el-col>
                  <small>φ.π.α.</small>
                  {{ $theMoney(aggregators.costincl - aggregators.cost) }}&euro;
                </el-col>
              </el-row>
            </el-col>
          </el-row> -->
          <s-responsive-panel
              :go-responsive="1020"
              :caption="$theMoney(aggregators.costincl) + '&euro;'"
              style="margin: 10px"
          >
            <el-col :sm="8" >
              <h3 >
                <small >καθ.αξια</small >
                {{ $theMoney(aggregators.cost) }}&euro;
              </h3 >
            </el-col >
            <el-col :sm="8" >
              <h3 >
                <small >φ.π.α.</small >
                {{ $theMoney(aggregators.costincl - aggregators.cost) }}&euro;
              </h3 >
            </el-col >
            <el-col :sm="8" >
              <h3 >
                <small >αξια</small >
                {{ $theMoney(aggregators.costincl) }}&euro;
              </h3 >
            </el-col >
          </s-responsive-panel >
        </el-card >
        <!-- <h4 v-else class="quoted dark" style="text-align:center">Παρακαλώ επιλέξτε πελάτη</h4> -->
        <el-row v-if="selectedInvoice.timologioId" >
          <el-tabs
              tab-position="left"
              style="height: 100%" >
            <el-tab-pane >
              <span slot="label" >
                <i
                    class="fas fa-clipboard-list"
                    :title="
                    useItAsTransDescription
                      ? 'περιγραφή στο παραστατικού'
                      : 'σχόλιο παραστατικού'
                  "
                ></i >
              </span >

              <transactions-panel
                  :disabled="!canEdit"
                  :invoice-data="selectedInvoice"
                  :business-id="selectedInvoice.businessId"
                  @transctionsChanged="updateCosts"
              ></transactions-panel >
            </el-tab-pane >
            <el-tab-pane >
              <span slot="label" >
                <i class="far fa-comment-alt" ></i >
              </span >
              <br />

              <el-row >
                <el-input
                    v-model="selectedInvoice.comments"
                    :disabled="!canEdit"
                    type="textarea"
                    :rows="5"
                    placeholder="σχόλιο/περιγραφή"
                    @input="updateInvoice(null, true)"
                ></el-input >
              </el-row >
              <br />
              <el-row >
                <el-alert
                    type="success"
                    :closable="false" >
                  <p >Στην εκτύπωση θα χρησιμοποιηθεί ως</p >

                  <el-switch
                      v-model="useItAsTransDescription"
                      :disabled="!canEdit"
                      active-text=" περιγραφή στο παραστατικό"
                      inactive-text=" απλό σχόλιο"
                  ></el-switch >
                </el-alert >
              </el-row >
            </el-tab-pane >
          </el-tabs >
        </el-row >
      </div >
      <el-drawer
          class="dark"
          append-to-body
          round
          title="SUMS"
          position="right"
          direction="rtl"
          size="50%"
          :visible.sync="showSums"
          get-container="#app"
      >
        <el-row
            v-for="(Sum, idx) in Sums"
            :key="idx" >
          <el-col :md="6" >
            <h2 style="text-align: center" >
              {{ Sum.kind == "receipt" ? "ΑΠΥ" : "" }}{{ Sum.kind == "invoice" ? "ΤΙΜΟΛΟΓΙΑ" : "" }}{{ Sum.kind == "pistotiko" ? "ΠΙΣΤΩΤΙΚΑ" : "" }}
              <small >
                σ: {{ Sum.timo_group }}
              </small >
            </h2 >
          </el-col >
          <el-col :md="9" >
            <div >
              <h4 class="text-center" >Σύνολα πιστώσεων</h4 >

              <h3 class="text-center" >
                <i class="material-icons" >functions</i > {{ Sum.total }}
              </h3 >
              <h3 class="text-center" >
                <small >+ΦΠΑ:</small >
                {{ Sum.totalvat }}
              </h3 >
              <h3 class="text-center" >={{ Sum.totalall }}</h3 >
            </div >
          </el-col >
          <el-col :md="9" >
            <div >
              <h4 class="text-center" >Σύνολα πληρωμών</h4 >

              <h3 class="text-center" >
                <small >Εξωφλημένα:</small >
                {{ Sum.totalpayed }}
              </h3 >
              <h3 class="text-center" >
                <small >Ανεξώφλητα:</small >
                {{ Sum.totalnotpayed }}
              </h3 >
            </div >
          </el-col >
        </el-row >

        <el-row style="padding-bottom: 5px" >
          <el-col :md="12" >
            <s-action-pannel >
              <el-button
                  slot="actions"
                  type="primary"
                  plain
                  @click="exportEXCEL()"
              >
                <i class="material-icons" >file_download</i >
              </el-button >
              <span >Λήψη Τιμολογίων (excel)</span >
            </s-action-pannel >
          </el-col >
          <el-col :md="12" >
            <s-action-pannel >
              <el-button
                  slot="actions"
                  type="primary"
                  plain
                  @click="exportEXCEL('grouped')"
              >
                <i class="material-icons" >perm_identity</i > <i class="material-icons" >file_download</i >
              </el-button >
              <span >Λήψη ΜΥΦ (excel)</span >
            </s-action-pannel >
          </el-col >
          <!-- <el-col :md="8">
            <s-action-pannel @click="exportAADE()">
              <el-button slot="actions" type="success" plain>
                <i class="material-icons">forward_to_inbox</i>
              </el-button>
              <span>Αποστολή ΑΑΔΕ</span>
            </s-action-pannel>
          </el-col> -->
        </el-row >
        <el-card >
          <el-row slot="header" >
            <s-action-pannel @click="exportAADE()" >
              <el-button
                  slot="actions"
                  type="success"
                  plain >
                <i class="material-icons" >forward_to_inbox</i >
              </el-button >
              <span >Αποστολή ΑΑΔΕ</span >
            </s-action-pannel >
          </el-row >
          <h4 >
            <el-row :gutter="10" >
              {{ aadeMsgs }}
            </el-row >
          </h4 >
          <div
              style="height: 50vh; overflow: auto"
              v-if="aadeErrors && aadeErrors.length"
          >
            <el-row
                v-for="invEr in aadeErrors"
                :key="invEr.inv_id"
                :gutter="10"
            >
              <el-col :span="6" >{{ invEr.aa }}</el-col >
              <el-col :span="18" >
                <el-row
                    v-for="(err, idx) in invEr.errors"
                    :key="idx" >{{ err }}
                </el-row >
              </el-col >
            </el-row >
          </div >
        </el-card >
      </el-drawer >
    </div >
  </sc-panel-navigator >
</template >

<script >
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import format from "date-fns/format";
import * as api from "~/api/resource";
import {async} from "q";

export default {
  data() {
    return {
      aadeMsgs: null,
      showSums: false,
      aadeErrors: null,
      clock: 1,
      Sums: [],
      dtshorts: [
        {key: "lastWeek", label: "Πργ. Εβδομ."},
        {key: "thisWeek", label: "Τρχ. Εβδομ."},

        {
          key: "nextWeek",
          label: "Επμ. Εβδομ."
        },
        // { key: "last7Days", label: "Last 7 days", value: 7 },
        // { key: "last30Days", label: "Last 30 days", value: 30 },
        {key: "lastMonth", label: "Πργ. Μήνας"},
        {key: "thisMonth", label: "Τρχ. Μηνας"},

        {
          key: "nextMonth",
          label: "Επμ. Μηνας"
        },
        {key: "lastYear", label: "Πργ. Ετος"},
        {key: "thisYear", label: "Φέτος"}
      ],
      selectedSira: "invoice",
      selectedTimoGroup: null,
      selectedInvoiceToMoveTrans: null,
      useItAsTransDescription: false,
      showDetails: false,
      workingBusiness: null,
      drawerIsOpen: true,
      searchBusiness: null,
      searchTransactions: null,
      invoiceState: "all",
      dateRange: [],
      listedInvoices: [],
      selectedInvoice: {},
      canEdit: true,
      aggregators: {
        cost: 0,
        costincl: 0
      },
      contentFrame: "width:calc(100vw - 700px);",
      drawerWidth: window.innerWidth < 500 ? window.innerWidth : 500,
      loaded: false,
      processing: false,
      userProfile: UserProfile,
      printerLang: "gr",
      dateFormat: "DD/MM/YY"
    };
  },
  computed: {
    printLink() {
      var urlprfx = "";
      // _log_("the rs///", this.workingBusiness);
      if (this.workingBusiness && this.workingBusiness.externalLinkId) {
        var prfx = this.workingBusiness.externalLinkId.split("printer:");
        if (prfx[1] && prfx[1] != "") urlprfx = prfx[1] + "-";
      }
      var l =
          urlprfx +
          (this.useItAsTransDescription ? "compact-" : "") +
          this.userProfile.printer_link;
      l +=
          "&pdf=full&objectId=" +
          this.selectedInvoice.timologioId +
          "&headerHeight=51&objectClass=Timologio&action=view&printmode=" +
          this.printerLang;
      return l;
      //"printerPrfx()+'[[!~[[!+printer:getPrinter]]]]&pdf=full&objectId='+Timologio.timologioId+'&headerHeight=51&objectClass=Timologio&action=view&printmode='+Lang"
    },
    range: {
      set(range) {
        this.$store.commit("dateRange", range);
      },
      get(range) {
        return this.$store.state.dateRange;
      }
    },
    qInvoices() {
      return {
        sort: "aa",
        dir: "DESC",
        // sira: "invoice",
        issue_state: this.invoiceState,
        sira: this.selectedSira,
        timo_group: this.selectedTimoGroup ? this.selectedTimoGroup : "Α",
        search: this.searchBusiness,
        searchdaterange:
            this.dateRange && this.dateRange[0] && this.dateRange[1]
                ? this.dateRange[0] + "-" + this.dateRange[1]
                : null
      };
    },

    colDefinitions() {
      return [
        //  {
        //   prop: "idx",
        //   width: "",
        //   label: "i."
        //  },
        {
          prop: "aa",
          width: "",
          label: "Α.Α.",
          mLabel: "",
          formatter(val, colDefs, row) {
            if (val == 0) return "";
            if (row.aade_uid)
              val =
                  '<i class=" fab fa-expeditedssl"></i>' +
                  val;
            val += (row.payed ? '<i class="far fa-thumbs-up"></i>' : "")
            return (
                '<span style="float:left" class="el-tag el-tag--' +
                (row.canceled == 1 ? "danger" : "success") +
                ' el-tag--light">' +
                val +
                "</span>"

            );
          }
        },
        {mLabel: "", prop: "date", width: "90px", label: "Ημ/νια"},
        {mLabel: "", prop: "business_name", width: "200px", label: "Πελατης"},

        // {
        //   prop: "cost",
        //   width: "100px",
        //   label: "Κοστος",
        //   formatter(val, colDefs, row) {
        //     if (val) return parseFloat(val).formatMoney(2) + "&euro;";
        //     return "-";
        //   }
        // },

        {
          mLabel: "",
          prop: "costwithvat",
          width: "100px",
          label: "Με ΦΠΑ",
          formatter(val, colDefs, row) {
            if (val) return parseFloat(val).formatMoney(2) + "&euro;";
            return "-";
          }
        }
      ];
    }
  },
  watch: {
    // selectedSira(val, oldvl) {
    //   _log_("oe.S..", val, oldvl);
    //   if (!val) return;
    //   if (!oldvl) return;
    //   if (val && val == oldvl) return;
    //   if (val == this.$route.query.kind) return;
    //   this.$router.replace({
    //     name: "timologiera",
    //     query: { kind: val },
    //     params: { id: null }
    //   });
    //   this.selectedInvoice = {};
    //   ++this.clock;
    // },
    "selectedInvoice.print_type"(val, oldvl) {
      if (val == oldvl) return;
      if (this.selectedInvoice.print_type == "compact")
        this.useItAsTransDescription = true;
      else this.useItAsTransDescription = false;
    },
    useItAsTransDescription(val, oldvl) {
      if (val == oldvl) return;
      if (val === true) this.selectedInvoice.print_type = "compact";
      else this.selectedInvoice.print_type = "normal";
      this.updateInvoice(null, true);
    },
    "$route.query.kind"(v, vo) {
      if (!v) return;
      _log_("oe.SRR..", v, vo);
      if (v == vo) return;
      if (this.selectedSira != this.$route.query.kind)
        this.selectedSira = this.$route.query.kind;
    },
    "$route.name": {
      handler: async function (nm, nmold) {
        _log_("rrrole.11..." + nm, this.$route.params.id);
        if (nm == nmold) return;
        if (nm == "timologiera" || nm == "timologio")
          if (!this.$route.params.id) this.selectedInvoice = {};
      },
      deep: true,
      immediate: true
    },
    "$route.params.id": {
      handler: async function (timid, oldid) {
        _log_("rrrole.11...", timid);
        if (this.$route.name != "timologio") return;
        if (!timid || timid == oldid || timid == "all") return;
        if (!timid) {
          this.selectedInvoice = {};
          return;
        }

        if (timid == "new") {
          this.newInvoice();
          return;
        }
        var {data} = await api.fetchProcessor("timologio/get", {
          timologioId: timid
        });
        if (data) {
          this.canEdit =
              !data.object.aa ||
              data.object.aa + "" == "0" ||
              data.object.aa + "" == "";
          this.selectedSira = data.object.kind;
          this.$router.replace({query: {kind: this.selectedSira}});
          this.$nextTick(() => {
            this.selectedInvoice = data.object;
            this.$refs.listedInvoices.brinkOnViewOrAppend(
                this.selectedInvoice,
                {
                  timologioId: this.selectedInvoice.timologioId
                }
            );
          });
          _log_("read....", this.selectedInvoice);
        }
      },
      deep: true,
      immediate: true
    }
    // async "selectedInvoice.businessId"(val, oldval) {
    //    _log_("ore.ssss..", val);
    //   if (val && val != oldval) {
    //     if (!this.selectedInvoice.nvoiceid) {
    //       //new
    //       const data = await api.updateProcessor(
    //         "timologio/update",
    //         this.selectedInvoice
    //       );
    //       _log_("ore...", data);
    //     }
    //   }
    // }
  },
  async mounted() {
    if (this.$route.query.kind) this.selectedSira = this.$route.query.kind;
    const date = new Date();
    this.qRange = [date.getTime(), date.getTime() + 3600 * 1000 * 24 * 91];
    // this.toggleDrawer(true);
    if (window.innerWidth > 901) this.heightWish = "50%";
    else this.heightWish = "50%";
    if (this.isMobileDevice()) this.heightWish = "100%";
    if (this.userProfile && this.userProfile.invoiceGroups) {
      for (const key in this.userProfile.invoiceGroups) {
        if (this.userProfile.invoiceGroups.hasOwnProperty(key)) {
          this.selectedTimoGroup = this.userProfile.invoiceGroups[key];
          break;
        }
      }
    }
    this.loaded = true;

    // _log_("the rs///", this.userProfile);
  },
  methods: {
    async exportAADE(justThisInvoice) {
      this.processing = true
      this.aadeErrors = [];
      const qI = justThisInvoice
          ? {timologioId: this.selectedInvoice.timologioId}
          : {
            ...this.qInvoices,
            limit: 0
          };
      this.aadeMsgs =
          "Παρακαλώ περιμένετε τα μαγειρευουμε παρέα με την εφορεία";
      var {data} = await api.fetchProcessor("timologio/aade_bridge", qI);
      // _log_("ore..D.", data.results);

      for (const invAade of data.results) {
        if (invAade.errors)
          this.aadeErrors.push({
            aa: invAade.invoiceObject.aa,
            errors: invAade.errors
          });
        // _log_("ore..D.", invAade);
      }
      this.aadeMsgs =
          this.dateFromUnxTime(this.unxnow(), true) +
          " στάλθηκαν " +
          data.results.length +
          " παραστατικα " +
          (!data.errors
              ? " oλα με επιτυχία"
              : " υπήρχαν " + data.errors + " αποτυχίες");
      if (justThisInvoice) {
        this.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          duration: !data.errors ? 3000 : 0,
          type: !data.errors ? 'success' : 'error',
          message: this.aadeMsgs + (!data.errors ? '' : '<p>' + data.errors.join('<br/>') + '</p>')

        });
      }
      this.processing = false
      // data.results.forEach((res) => {});
    },
    exportEXCEL(what) {
      var endpoint = UserProfile.exporter_processor
          ? UserProfile.exporter_processor
          : "simpleexporter";
      what = what ? what + "_" : "";

      this.ajax_download("gears/" + what + endpoint, this.qInvoices);
      //  {
      //   searchdaterange: this.dateRange,
      //   sira: this.selectedSira,
      //   timo_group: this.selectedTimoGroup
      // });
    },
    async displaySums() {
      var q = this.qInvoices;
      const d = await api.fetchProcessor("timologio/getlist", {
        ...q,
        mode: "sums",
        invoice_state: 1
      });
      _log_("ddd...", d.data.results);
      this.Sums = d.data.results;
      this.showSums = true;
    },
    moveTransactions() {
      if (this.selectedInvoiceToMoveTrans)
        this.selectedInvoiceToMoveTrans = null;
      else {
        this.selectedInvoiceToMoveTrans = this.selectedInvoice.timologioId;
        this.$notify({
          title: "Μετακινησε περιεχομενου παραστατικού",
          message:
              "Στην λίστα με τα παραστατικά δεξιά κάνε κλικ πάνω σε αυτό που θέλεις να μεταφέρεις το περιεχόμενο"
        });
      }
    },
    deleteInvoice() {
      const vm = this;
      this.$confirm("Θελεις να το διαγράψετε;", "ΠΡΟΣΟΧΗ!!!", {
        confirmButtonText: "Ναι",
        cancelButtonText: "Άστο καλήτερα",
        type: "warning",
        center: true
      })
          .then(async () => {
            var {data} = await api.removeObject(
                "timologio",
                vm.selectedInvoice
            );
            if (data.success)
              vm.removeArrayElement(
                  vm.listedInvoices,
                  vm.selectedInvoice,
                  "timologioId"
              );
            else
              vm.$message.error(
                  "Αυτο το παραστατικο δεν ειναι δυνατον να διαγραφεί"
              );

            _log_("r....", data);
          })
          .catch(() => {
          });
    },
    handlePayment() {
      const vm = this;
      // _log_(
      //   "tr.!!!!!!!!!!!!!!!!!.." + this.aggregators.costincl,
      //   this.selectedInvoice.costwithvat,
      //   Math.abs(
      //     parseFloat(this.selectedInvoice.costwithvat) +
      //       parseFloat(this.workingBusiness.balance)
      //   )
      // );
      if (vm.selectedInvoice.payed == 1) {
        this.$confirm("θελετε να ακυρώσετε την πληρωμή?", "! προσοχή", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        })
            .then(async () => {
              vm.selectedInvoice.payed = 0;

              vm.selectedInvoice.forcePayment = null;
              await vm.updateInvoice();
              // ++vm.clock;
            })
            .catch(() => {
            });
      } else {
        if (
            Math.abs(
                parseFloat(this.selectedInvoice.costwithvat) +
                parseFloat(this.workingBusiness.balance)
            ) > 0.01
        )
          this.$prompt(
              "Ο συγκεκριμένος πελάτης" +
              (this.workingBusiness.balance < 0
                  ? " χρωστάει "
                  : " του χρωστάμε ") +
              this.$theMoney(this.workingBusiness.balance),
              "Τι λεφτά μας έδωσε;",
              {
                confirmButtonText: "Πλήρωσε το παραπάνω ποσό",
                cancelButtonText: "Ακυρω",
                inputValue: this.$theMoney(this.selectedInvoice.costwithvat)
              }
          )
              .then(async ({value}) => {
                vm.selectedInvoice.payed = 1;
                // _log_('pay...',value,this.$theMoney(value, true))
                vm.selectedInvoice.forcePayment = this.$theMoney(value, true);
                await vm.updateInvoice();
                // ++vm.clock;
              })
              .catch(() => {
              });
        else {
          vm.selectedInvoice.payed = 1;

          vm.selectedInvoice.forcePayment = this.selectedInvoice.costwithvat;
          vm.updateInvoice();
        }
      }
      // if(this.aggregators.costincl)
    },
    cancelInvoice() {
      const vm = this;
      if (this.selectedInvoice.aa && this.selectedInvoice.aa + "" != "0")
        this.$confirm(
            "Θελεις να το " +
            (vm.selectedInvoice.canceled != 1 ? "ακυρώσεις" : "επαναφερεις"),
            "ΠΡΟΣΟΧΗ!!!",
            {
              confirmButtonText: "Ναι",
              cancelButtonText: "Άστο καλήτερα",
              type: "warning",
              center: true
            }
        )
            .then(() => {
              vm.selectedInvoice.canceled =
                  vm.selectedInvoice.canceled == 1 ? 0 : 1;
              vm.updateInvoice(vm.selectedInvoice);
            })
            .catch(() => {
            });
    },
    invoiceListClass(k) {
      var cls = "";
      if (this.selectedInvoiceToMoveTrans) cls += " wait ";
      if (k.row.canceled == 1) cls += " canceled-invoice";
      if (k.row.aa > 0) cls += " issued-invoice";
      else cls += " not-issued-invoice";
      return cls;
    },
    selectInvoiceState(k) {
      if (k == "gadgets") this.displaySums();
      else this.invoiceState = k;
    },
    updateCosts(transs) {
      // return
      // _log_("tr.!!!!!!!!!!!!!!!!!..", transs);
      const vm = this;
      vm.aggregators = {
        cost: 0.0,
        costincl: 0.0
      };
      transs.forEach(element => {
        if (!isNaN(parseFloat(element.cost)))
          vm.aggregators.cost += parseFloat(element.cost);
        if (!isNaN(parseFloat(element.costincl)))
          vm.aggregators.costincl += parseFloat(element.costincl);
      });
      _log_("tr.!!!!!!!!!!!!AA!!!!!..", vm.aggregators);
      this.selectedInvoice.cost = vm.aggregators.cost;
      this.selectedInvoice.costwithvat = vm.aggregators.costincl;
      this.$refs.listedInvoices.updateRow(
          {timologioId: this.selectedInvoice.timologioId},
          this.selectedInvoice
      );
      // this.updateArrayElement(
      //   this.listedInvoices,
      //   this.selectedInvoice,
      //   "timologioId",
      //   true
      // );
    },
    async issueInvoice() {
      this.selectedInvoice.open = 0;
      this.selectedInvoice.editable = 0;
      const data = await this.updateInvoice();
      return data;
    },
    async updateInvoice(inv_data, silent) {
      _log_(
          "inv is..." + this.selectedInvoice.timologioId,
          this.selectedInvoice
      );
      if (!inv_data) inv_data = this.selectedInvoice;
      if (!inv_data) return;
      try {
        const data = await api.updateProcessor("timologio/update", inv_data);
        if (!silent) {
          const reloadRoute = this.selectedInvoice.timologioId === null;
          this.selectedInvoice = data;
          // _log_("inv is...", this.selectedInvoice);
          // this.updateArrayElement(
          //   this.listedInvoices,
          //   this.selectedInvoice,
          //   "timologioId",
          //   true
          // );
          this.$refs.listedInvoices.updateRow(
              {timologioId: this.selectedInvoice.timologioId},
              this.selectedInvoice
          );
          if (reloadRoute)
            this.$router.push({
              name: "timologio",

              params: {
                id: data.timologioId
              },
              query: this.$route.query
            });
        }
        return data;
      } catch (e) {
        if (e.message && e.message.message)
          this.$notify.error({
            title: "Το παραστατικό δεν αποθηκεύτηκε!!!",
            message: e.message && e.message.message
          });
        return false;
      }
      return false;
    },
    newInvoice() {
      this.canEdit = true;
      // this.selectedInvoice = null;
      this.selectedInvoice = {
        timologioId: null,
        editable: 1,
        aa: 0,
        open: 1,
        date: format(new Date(), "DD/MM/YYYY"),
        vat: 24,
        kind: this.selectedSira
      };
      if (this.selectedTimoGroup)
        this.selectedInvoice.timo_group = this.selectedTimoGroup;
      //
      // this.$refs.listedInvoices.appendTrackedData(this.selectedInvoice, true);
      // _log_("hell..cccIII.", this.selectedInvoice);
      // this.listedInvoices.unshift(this.selectedInvoice);
      // this.$refs.listedInvoices.appendRecord(this.selectedInvoice)
    },
    toggleDrawer(v) {
      this.$refs.sidePanel.toggle(v);
    },
    async changeBusiness(e) {
      this.workingBusiness = e;
      _log_("hell..cccIII.", this.selectedInvoice);
      if (this.selectedInvoice.businessId != e.businessId) {
        this.selectedInvoice.businessId = e.businessId;
        if (this.selectedInvoice.aa) {
          if (
              confirm(
                  "Αυτο το παραστατικό έχει εκδωθεί απο της " +
                  this.selectedInvoice.date +
                  " πας να αλλάξεις τον πελάτη σύγουρα το θές?"
              )
          )
            await this.updateInvoice();
        } else await this.updateInvoice();
      } else {
        this.selectedInvoice.business_name = e.name;
        this.selectedInvoice.business_afm = e.afm;
        this.selectedInvoice.business_alias = e.alias;
        this.$refs.listedInvoices.updateRow(
            {timologioId: this.selectedInvoice.timologioId},
            this.selectedInvoice
        );
      }

      _log_("changed....", this.selectedInvoice);
      // if (this.selectedInvoice.nvoiceid) {
      //new

      // this.$refs.updateInvoices.appendRecord(this.selectedInvoice)

      // }
      // e=>(selectedInvoice.businessId=e.businessId)
    },
    handleContentFrame(pix) {
      if (this.isMobileDevice()) {
        this.contentFrame = "width:100vw;";
        return;
      }
      if (pix === true) {
        this.drawerIsOpen = pix;
        pix = this.drawerWidth;
      }
      if (pix === false) {
        this.drawerIsOpen = pix;
        pix = 0;
      }
      // pix=700
      if (_.isNumber(pix)) {
        if (window.innerWidth - pix < 700) pix = 0;
        this.contentFrame = "width:calc(100vw - " + (pix + 3) + "px);";
      }
    },
    async copyInvoice() {
      var inv_data = this.selectedInvoice;
      if (!inv_data) return;
      try {
        const data = await api.updateProcessor("timologio/create", inv_data);

        if (data) {
          this.listedInvoices.unshift(data);
          this.$router.push({
            name: "timologio",

            params: {
              id: data.timologioId
            },
            query: this.$route.query
          });
        }
      } catch (e) {
        if (e.message && e.message.message)
          this.$notify.error({
            title: "Το παραστατικό δεν αποθηκεύτηκε!!!",
            message: e.message && e.message.message
          });
        return false;
      }
      return false;
    },
    loadInvoice(d) {
      if (this.selectedInvoiceToMoveTrans) {
        const vm = this;
        this.$confirm(
            "Θελεις να το μεταφέρεις ολες τις κινησεις σε αυτό το παραστατικό;",
            "ΠΡΟΣΟΧΗ!!!",
            {
              confirmButtonText: "Ναι",
              cancelButtonText: "Άστο καλήτερα",
              type: "warning",
              center: true
            }
        )
            .then(async () => {
              var {data} = await api.fetchProcessor("gears/tools", {
                do: "move-trans",
                fromInv: vm.selectedInvoiceToMoveTrans,
                toInv: d.row.timologioId
              });
              vm.selectedInvoiceToMoveTrans = null;
              // _log_("r....", data);
            })
            .catch(() => {
            });
      } else {
        _log_("hell..ss.", d.row);
        this.$router.push({
          name: "timologio",
          params: {
            id: d.row.timologioId
          },
          query: this.$route.query
        });
        if (window.innerWidth < 900) this.toggleDrawer();
      }
      // this.canEdit = !d.row.aa || d.row.aa + "" == "0" || d.row.aa + "" == "";
      // this.selectedInvoice = d.row;
    },

    alert(msg) {
      _log_("hell...", msg);
    },
    setRange(dateOne, dateTwo) {
      this.qRange = [new Date(dateOne).getTime(), new Date(dateTwo).getTime()];
    },
    formatDates() {
      const dateOne = this.qRange[0],
          dateTwo = this.qRange[1];
      // this.qRange = [new Date(dateOne).getTime(), new Date(dateTwo).getTime()];
      let formattedDates = "";
      if (dateOne && dateOne != "") {
        formattedDates = format(new Date(dateOne), this.dateFormat);
      }
      if (dateTwo && dateTwo != "") {
        formattedDates += " - " + format(new Date(dateTwo), this.dateFormat);
      }
      return formattedDates;
    },

    goToInvoice(data) {
      _log_("bokk,,,", data);
      window.open(
          "/invoices/&invoiceid=" +
          data.row.inv_timologioId +
          "&sira=" +
          data.row.inv_kind +
          "&timo_group=" +
          data.row.inv_timo_group,
          "_blank"
      );
      // this.$router.push({
      //   name: "EditBooking",
      //   query: { bkid: data.row.idBooking }
      // });
    }
  }
};
</script >

<style >
.dark .el-tabs__item.is-active {
  color: aliceblue;
}

.dark .el-switch__label.is-active {
  color: rgb(239, 245, 239);
  font-weight: bold;
}

.dark .el-tabs__item {
  color: steelblue;
}

.dark .el-switch__label {
  color: rgb(103, 182, 143);
}

.search.x-row {
  align-items: flex-start;
}

.title {
  color: aliceblue;
  text-align: center;
}

.has-more {
  color: red;
  font-weight: 700;
}

div.el-radio-group.invoice-options {
  float: left;
  width: 100%;
}

.invoice-options.el-radio-group .el-radio-button {
  width: 33%;
}

.invoice-options.el-radio-group .el-radio-button .el-radio-button__inner {
  width: 100%;
}

.print_lang {
  font-size: 15px;
  line-height: 41px;
}

.wait {
  background-color: rgba(177, 173, 125, 0.329) !important;
}

.btn_left {
  display: flex;
}

.square_btn_left {
  flex: 2;
}

.round_btn_left {
  flex: 1;
}

div.stamp {
  width: 150px;
  float: right;
}

div.stamp * {
  padding: 2px;
  /*color: #095b69 !important;*/
  /*background-color: wheat !important;*/
}

/* .actions_btns .fa-cog {
  color: #ffffff;
} */
@media screen and (max-width: 1200px) {
  .btn_left {
    flex-direction: column;
    position: absolute;
    z-index: 1;
    padding: 15px;
    background: #095b69;
    border: #ffffff solid 1px;
    border-radius: 10px;
  }

  .square_btn_left {
    padding-bottom: 15px;
  }
}

@media screen and (max-width: 769px) {
  .responsive-items button {
    margin-left: 0px !important;
    margin-right: 5px;
    margin-bottom: 5px;
  }

  .square_btn_left {
    flex: 1;
  }

  .responsive-items {
    position: absolute;
    top: 35px;
    left: 0px;
    width: 100%;
    z-index: 1;
    background: #095b69;
    padding: 10px;
  }

  .round_btn_left {
    text-align: right;
  }
}
</style >
